import api from './api';

const genAIAdminToken = process.env.REACT_APP_GENAI_ADMIN_SECURITY_TOKEN;

const UserPackagesManagementApi = {
  getUserPackages: (params = {}) =>
    api.get('/genai-admin/user-packages', {
      params,
      headers: { 'secure-token': genAIAdminToken },
    }),

  getPackages: (params = {}) =>
    api.get('/genai-admin/packages', {
      params,
      headers: { 'secure-token': genAIAdminToken },
    }),

  updateUserCredits: (userId, data) =>
    api.patch(`/genai-admin/user-packages/user/${userId}/credits`, data, {
      headers: { 'secure-token': genAIAdminToken },
    }),

  updateUserPackage: (data) =>
    api.post('/genai-admin/user-packages/purchase', data, {
      headers: { 'secure-token': genAIAdminToken },
    }),
};

export default UserPackagesManagementApi;
